export const $win = $(window);

export function getCurrentDevice() {
	let currentDevice = 'desktop';
	if ($win.width() <= 767) {
		currentDevice = 'mobile'
	} else if ($win.width() < 1200) {
		currentDevice = 'tablet'
	} else {
		currentDevice = 'desktop'
	}
	return currentDevice;
}
